import * as util from 'lib/util.js'
import { Router } from '@vaadin/router/dist/vaadin-router.js';
import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {storeInstance} from "store/index.js";
import "./kb-folders.js";
import "./kb-folderview-files.js";

class KbFolderview extends (LitElement)   {
    constructor(){
        super();
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
        });
        this.state = storeInstance.state
        this.string = this.state.strings;
        this.addEventListener('folderItemClicked', this._handleFolderItemClicked.bind(this));
        if(this.state.item){
            this.refresh();
        }
    }

    _handleFolderItemClicked(e){
        var node = e.detail;
        if(node.id!=this.folderId){
            // storeInstance.dispatch("setState", {property: "selectedFolder", value: node } )
            this.fileid = null;
            this.folderId = node.id;
            history.pushState(null, null, "/kb/" + this.state.langCode + "/" + this.state.item.item.externalId + "/folder/" + node.id );
            storeInstance.dispatch("touch");
        }
    }

    refresh(){
        storeInstance.dispatch("getFoldersForKbrid", {externalId: this.state.item.item.externalId ,langCode:this.state.langCode} )
    }

    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
    }

    _setSelected(node, selectedId){
        if(node.id==selectedId){
            node.selected=true;
            this.selectedNode=node;
            // storeInstance.dispatch("setState", {property: "selectedFolder", value: node } )
        } else {
            node.selected=false;
        }
        if(node.children){
            for(var i=0;i<node.children.length;i++){
                this._setSelected(node.children[i], selectedId)
            }
        }
    }
    _openParents(node){
        node.open=true;
        if(node.hasOwnProperty("parent")){
            this._openParents(node.parent);
            }
        }

    stateChange(state){
        this.state = state;
        this.string = this.state.strings;
        if(this.state.folder_tree){
            
            if(!this.rootnode){
                //this.kbrid = this.kbrid ? this.kbrid : this._recurseToHREF(this.state.item_toc[0]) ;  //if no kbrid passed in, then find first in toc
                this.rootnode =this.state.folder_tree;
                util.setParents(this.rootnode);
            }
            if(!this.folderId){
                if(this.rootnode.hasOwnProperty("children")){
                    if(this.rootnode.children.length>0){
                        this.folderId = this.rootnode.children[0].id;
                    }
                }
            }
            
            if(this.folderId!=this.lastFolderId){
                this.lastFolderId = this.folderId;
                this._setSelected(this.rootnode, this.folderId);
            }
            if(this.selectedNode){
                if(this.selectedNode.hasOwnProperty("parent")){
                    this._openParents(this.selectedNode.parent);
                }
            }
            if(this.state.toc_open){
                this.leftSideWidthPerc = this.state.global_screen_specs.tocWidthPercent;
                this.rightSideWidthPerc = this.state.global_screen_specs.topicWidthPercent;
            } else {
                this.leftSideWidthPerc = 0;
                this.rightSideWidthPerc = 100;
            }
            this.myRender()
            
        }
        
    }

 
    myRender(){
        render(this.folderviewTemplate(), this.shadowRoot);
        if(!this.helpsetcontainer){
            this.helpsetcontainer = this.shadowRoot.querySelector("#helpsetcontainer")
            this.helpsetcontainer.addEventListener("splitter-dragend", this.updateScreenWidthSpecs.bind(this));
        } else {
            if(!this.state.toc_open){
                var leftPx = 0
                var rightPx = this.state.global_screen_specs.viewportWidth
            } else {
                var leftPx = parseInt(this.state.global_screen_specs.viewportWidth * this.leftSideWidthPerc)
                var rightPx = parseInt(this.state.global_screen_specs.viewportWidth * this.rightSideWidthPerc)
            }
            this.helpsetcontainer.children[0].style.flex = '1 1 ' + leftPx + 'px'
            this.helpsetcontainer.children[1].style.flex = '1 1 ' + rightPx + 'px' 
        }
        }
       
    updateScreenWidthSpecs(e){
        storeInstance.dispatch("setHelpsetLayoutWidths", {left: e.currentTarget.children[0].offsetWidth, right: e.currentTarget.children[1].offsetWidth} ) ;
        storeInstance.dispatch("setState", {property: "toc_open", value: (e.currentTarget.children[0].offsetWidth >0)    } )
        }

    _getSearchTerm(){
        var retval = "";
        if(this.state.search_term){
            if(this.state.search_term.item!="ROOT"){
                retval = this.state.search_term.searchterm;
            }
        }
        return retval
    }

        
    folderviewTemplate(){
       return html`<style>
                #leftside{
                    height: ${this.state.global_screen_specs.workspaceHeight}px;
                    overflow: auto;
                    width: ${this.leftSideWidthPerc}%;

                    color: var(--kb-on-primary-color);
                }
                #rightside{
                    height: ${this.state.global_screen_specs.workspaceHeight}px;
                    overflow: auto;
                    width: ${this.rightSideWidthPerc}%;
                    
                }
                #pagewrapper{
                    max-width:1024px;
                }
                #topicwrapper{
                    background-color: var(--kb-surface-color);
                    border: 1px solid black;
                    padding: var(--block-padding);
                    margin-top: var(--block-padding);
                    border: var(--kb-surface-border);
                    border-radius: var(--kb-border-radius);
                }
                
                #search{
                    margin: .5rem 1.5rem .5rem 1.5rem; 
                }
                #searchbtn{
                    padding-left:1rem;
                    cursor:pointer;
                }                
                iframe{
                    height: ${this.state.global_screen_specs.workspaceHeight-10}px;
                    width: ${this.rightSideWidthPerc}%;
                    overflow: hidden;
                }
            </div>
            </style>
            <vaadin-split-layout id="helpsetcontainer">
                <div id='leftside'>

                
                    <kb-folders .rootnode="${this.rootnode}" .folderid="${this.folderId}"></kb-folders>
                </div>
                <div id='rightside'>
                    <div id='pagewrapper'>
                            ${this._rightSideTemplate()}
                            
                    </div>        
                </div>
            </vaadin-split-layout>`
        }
         
            /*
            <div id='search'>
                <iron-icon id="" icon="vaadin:close-small" @click="${this._clearSearch.bind(this)}"></iron-icon>
                <ui5-input id='searchbox' @keyup="${this.checkEnterKey.bind(this)}" placeholder="${this.string["_helpsetsearch"]}" value="${this._getSearchTerm()}"></ui5-input>
                <iron-icon id="searchbtn" icon="vaadin:search" @click="${this._search.bind(this)}"></iron-icon>
            </div>
            */

        _clearSearch(){
            var searchbox = this.shadowRoot.querySelector("#searchbox")
            if(searchbox.value){
                if(window.location.pathname.toLowerCase().includes("/fvsearch/")){
                    var aTmp = window.location.pathname.split("/")
                    var tmpUrl = "/kb/" + aTmp[2] + "/" + aTmp[5]
                    history.pushState(null, null, tmpUrl);
                    } 
                searchbox.value="";
                }
                storeInstance.dispatch("setState", {property: "search_term" ,value: null } )
            }

        _rightSideTemplate(){
            if(this.searchview){
                return html`<kb-searchview id="folderview"></kb-searchview>`;
            } else {
                if(this.fileid){
                    /* return html`<iframe src="/kb/jrest/getResource?itemExtId=${this.state.item.item.externalId}&lblSeqId=${this.fileid}#toolbar=0" >` */
                    var strFrag = "#toolbar=0"
                    if(this.pagenum){
                        strFrag = "#toolbar=0&page=" + this.pagenum;
                        if(this.state.search_term){
                            strFrag = strFrag + "&search=" + this.state.search_term.searchterm;
                        }
                    }
                    return html`<iframe id="fred" style="border:1px solid #666CCC" title="PDF in an i-Frame" src="/kb/jrest/getResource?itemExtId=${this.state.item.item.externalId}&lblSeqId=${this.fileid}${strFrag}" frameborder="1" scrolling="auto" height="1100" width="850" ></iframe>`
                } else {
                    return html`<kb-folderview-files .folderId="${this.folderId}"></kb-folderview-files>`
                }
            }
        }
        

        checkEnterKey(e){
            if (e.key === 'Enter' || e.keyCode === 13) {
                this._search()
            }
        }

        _search(){
            var searchbox = this.shadowRoot.querySelector("#searchbox")
            history.pushState(null, null, "/kb/" + this.state.langCode + "/fvsearch/" + searchbox.value + "/" + this.state.item.item.externalId);
            Router.go("/kb/" + this.state.langCode + "/fvsearch/" + searchbox.value + "/" + this.state.item.item.externalId)
            storeInstance.dispatch("touch");    
        }
}

customElements.define('kb-folderview', KbFolderview)
